var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'cart__btn btn' + ' btn--' + _vm.$store.getters['auth/role'],attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.validCart($event)}}},[_c('span',{staticClass:"btn__text"},[_vm._v("Je valide mon panier")]),_vm._v(" "),_c('img',{staticClass:"btn__picto",attrs:{"src":"/static/img/pictos/valider.svg","alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d16ae56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart/CartValid.vue
// module id = 408
// module chunks = 0